import styles from './MetadataLabel.module.css';

type Props = {
  label: string;
  children: React.ReactNode;
};

const MetadataLabel = ({ label, children }: Props) => (
  <div className={styles.Container}>
    <h4>{children}</h4>
    <p>{label}</p>
  </div>
);

export default MetadataLabel;
